import { useMemo } from 'react';
import { useSelector } from 'js/store/hooks';
import { MAINTENANCE_MODE_REDUCER } from 'js/store/constants';

export const useIsIntegrationScriptFailed = () => {
    const { isMaintenanceEnabled, isAutoDetectEnabled, isIntegrationScriptFailed } = useSelector(
        (state) => state[MAINTENANCE_MODE_REDUCER]
    );

    return useMemo(() => ({
        isIntegrationScriptFailed: isMaintenanceEnabled && isAutoDetectEnabled && isIntegrationScriptFailed
    }), [isAutoDetectEnabled, isIntegrationScriptFailed, isMaintenanceEnabled]);
};
